import { TableCell, TableSortLabel } from '@material-ui/core';
import React from 'react';

const TableHeadCell = ({ paginationData, field, title, handleOrder }) => {
  return (
    <TableCell>
      <TableSortLabel
        active={ paginationData.ordered_by === field }
        direction={ paginationData.sorted ?? 'desc' }
        onClick={ async () => handleOrder(field) }
      >
        {title}
      </TableSortLabel>
    </TableCell>
  );
};

export default TableHeadCell;
